import Grid from "@components/Grid/Grid";
import clsx from "clsx";
import styles from "./C210_3_ArticleBlockQuote.module.scss";

export interface ArticleBlockQuoteProps {
  quoteText?: string;
  personName?: string;
  personDesignation?: string;
  displayAsLargeQuote?: boolean;
  inSublayout?: boolean;
}

export const ArticleBlockQuote = (props: {
  content: ArticleBlockQuoteProps;
}) => {
  const { content } = props;
  const {
    quoteText,
    personName,
    personDesignation,
    displayAsLargeQuote,
    inSublayout,
  } = content;

  return (
    <div className="wrapper">
      <Grid row>
        <Grid column sm={12} md={!inSublayout ? 8 : 12}>
          <section
            className={clsx(
              "component",
              "cf",
              styles["article-blockquote"],
              displayAsLargeQuote && styles["large-quote"]
            )}
          >
            <span>
              <blockquote>{quoteText}</blockquote>
              <p className="quote-name">{personName}</p>
            </span>
            <p className="quote-position">{personDesignation}</p>
          </section>
        </Grid>
      </Grid>
    </div>
  );
};

export default ArticleBlockQuote;
